<template>
  <div class='culture'>
    <v-breadcrumb>
      <button v-can:edit-exploitation class="primary-action flex-12 btn-icon enregistrer" type="button" @click="save(true)">Enregistrer</button>
    </v-breadcrumb>

    <v-module title='Culture et type de sol'>
      <v-row>
        <v-field-text name="complement" v-model="localCulture.complement" label="complément d'information" placeholder="ex : cultivé en sec ..." v-validate />
      </v-row>

      <v-row>
        <v-field-date v-if="isColzaCulture()" name="date_semis" v-model="localCulture.date_semis" label="Date de semis (entre le 01/08 inclus et le 30/09 inclus)" v-validate="'date_format:yyyy-MM-dd|date_between:2019-08-01,2019-09-30,include'" />
        <v-field-date v-else name="date_semis" v-model="localCulture.date_semis" label="Date de semis" placeholder="ex : 02/05/2015" v-validate />
        <v-field-select v-if="varietes.length" v-model="localCulture.id_ref_variete" label="Groupe de précocité / Variété" :options="varietes" valueField="id_ref_variete" labelField="nom" name="localCulture.id_ref_variete" data-vv-as="groupe précocité/variété" v-validate="'required'" />
      </v-row>

      <v-row>
        <v-field-select name="culture_precedente" v-model="localCulture.id_culture_precedente" label="Culture précédente" :options="culturePrec" valueField="id_culture_precedente" labelField="nom" v-validate />
      </v-row>

      <v-row>
        <v-field-integer v-validate='{ required : true , min_value : 0 }' v-model='localCulture.charge_fixe_irrigation' label='Charges opérationnelles (€/ha)' placeholder='ex : 530' name='charges_variables' data-vv-as='charges opérationnelles' :tooltip="true"/>
        <v-field-integer v-validate='{ required : true , min_value : 0 }' v-model='localCulture.charge_fixe' label='Charges fixes (€/ha)' placeholder='ex : 590' name='charges_fixes' data-vv-as='charges fixes' :tooltip="true"/>
        <v-field-integer v-validate='{ min_value : 0 }' v-model='localCulture.aides_specifiques' label='Aides spécifiques (€)' placeholder='ex : 320' name='aides_specifiques' data-vv-as='Aides spécifiques'/>
        <v-field-integer v-if="!localCulture.has_moyenne" v-validate='{ min_value : 0 }' v-model='localCulture.prix_par_tonne' label='Prix de vente (en €/tonne)' placeholder='ex : 250' name='prix_tonne' data-vv-as='Prix de vente (en €/tonne)' :tooltip="true"/>
        <v-field-integer v-else v-validate='{ required: true, min_value : 0 }' v-model='localCulture.prix_par_tonne' label='Prix de vente (en €/tonne)' placeholder='ex : 250' name='prix_tonne' data-vv-as='Prix de vente (en €/tonne)'/>
        <v-field-float v-validate="{ decimal : 2 }" :step="0.01" v-model='localCulture.temps_travail' label='Temps de traction hors irrigation (en h/ha)' placeholder='ex : 5.13' name='temps_travail' data-vv-as='Temps de traction hors irrigation (en h/ha)' :tooltip="true"/>
      </v-row>

      <div class="wrap">
        <input type="hidden"
               :value="solsString"
               name="sols"
               v-validate />
        <SolCultureTable :sols="sols" @deleteRow="deleteSol" @addRow="addSol" />
      </div>

    </v-module>

    <v-module title='Culture intermédiaire'>
      <button v-can:edit-exploitation class='action-btn flex items-center' @click='clearCipan'>Réinitialiser CIPAN</button>
      <v-row>
        <v-field-date name="date_semis_cipan" v-model="localCulture.date_semis_cipan" label="Date de semis" placeholder="ex : 02/05/2015" v-validate />
        <v-field-date name="date_levee_cipan" v-model="localCulture.date_levee_cipan" label="Date de levée" placeholder="ex : 02/05/2015" v-validate />
        <v-field-date name="date_destruction_cipan" v-model="localCulture.date_destruction_cipan" label="Date de destruction" placeholder="ex : 02/05/2015" v-validate />
      </v-row>

      <v-row>
        <v-field-select name="notes_dev_cipan" v-model="localCulture.note_dev_cipan" :allowEmpty="true" label="Note de développement du couvert" :options="notes" v-validate />
      </v-row>
    </v-module>

    <v-module title="Stratégie d'irrigation">
      <input type="hidden"
             :value="stadesString"
             name="stades"
             v-validate />
      <StadeTable :stades="stades" :idRefStadeFin="localCulture.id_ref_stade_fin" :idRefCulture="localCulture.id_ref_culture" @deleteRow="deleteStade" @addRow="addStade" />
      <v-field-select name="ref_stade_fin" v-model="localCulture.id_ref_stade_fin" :allowEmpty="true" label="Stade de fin" :options="refStades" valueField="id_ref_stade" labelField="nom" v-validate :tooltip="true"/>
    </v-module>

  </div>
</template>

<script>
import SolCultureTable from '@/components/SolCultureTable'
import StadeTable from '@/components/StadeTable'
import mixinConfirmation from '@/mixins/confirmation'
import { mapActions } from 'vuex'

export default {
  name: 'Culture',
  inject: ['$validator'],
  mixins: [mixinConfirmation],

  components: {
    SolCultureTable,
    StadeTable
  },

  props: {
    idExploitation: {
      type: String,
      require: true
    },
    idCulture: {
      type: String,
      require: true
    }
  },

  data () {
    return {
      localCulture: { ...this.$store.getters.getCultureById(this.idCulture) },

      sols: this.buildLocalSols(),
      stades: this.buildLocalStades(),
      notes: [
        {
          label: 'Peu développée',
          value: 1
        },
        {
          label: 'Moyennement développée',
          value: 2
        },
        {
          label: 'Très developpée',
          value: 3
        }
      ]
    }
  },

  created () {
    this.$store.commit('SET_CURRENT_CULTURE', this.idCulture)
    this.$store.dispatch('referentiel/loadCulturePrecs')
    this.$store.dispatch('referentiel/loadCultures').then(() => {
      if (this.localCulture.has_moyenne && this.localCulture.prix_tonne == null) {
        this.$validator.validate('prix_tonne')
      }
    })
    this.$store.dispatch('referentiel/loadStades')
    this.$store.dispatch('referentiel/loadVarietes')
    this.$store.dispatch('referentiel/loadTypeSols')
    this.$store.dispatch('referentiel/loadCultureStades')
  },

  computed: {
    culturePrec: function () {
      return this.$store.state.referentiel.culturesPrec.slice().sort((a, b) => a.nom.localeCompare(b.nom))
    },
    refStades () {
      let maxSelectedStadeOrder = this.stades.reduce(
        (max, stade) => Math.max(max, stade.ordre), 0)
      return this.$store.getters['referentiel/getStadesByCulture'](this.localCulture.id_ref_culture)
        .filter(stade => stade.ordre > maxSelectedStadeOrder)
    },
    varietes () {
      return this.$store.getters['referentiel/getVarietesForLocalCulture'](this.localCulture.id_ref_culture)
    },
    solsString () {
      return this.sols.map(s => s.id_ref_type_sol).join('-')
    },
    stadesString () {
      return this.stades.map(s => s.id_ref_stade).join('-')
    }
  },

  methods: {
    ...mapActions('alerte', ['alerte']),
    save (clicked = false) {
      let p = new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.dispatch('saveCulture', {
              ...this.localCulture,
              deletedSol: this.calculDeletedSol(),
              sols: this.sols,
              deletedStade: this.calculDeletedStade(),
              stades: this.stades
            })
              .then(() => {
                this.sols = this.buildLocalSols()
                this.stades = this.buildLocalStades()
                this.$store.dispatch('success', { message: 'Données enregistrées' })
                this.clearflags()
                resolve()
              })
              .catch((error) => {
                reject(new Error("Erreur lors de l'enregistrement" + error))
              })
          } else {
            reject(new Error('Des erreurs sont présentes'))
          }
        })
      })

      if (clicked) {
        p.catch(err => {
          this.alerte({
            title: 'Erreur',
            message: err.message || err,
            okTest: 'Ok'
          })
        })
      }
      return p
    },

    addSol (typeSol) {
      this.sols.push({
        ...typeSol,
        rendement: null
      })
    },
    deleteSol (typeSol) {
      this.sols.splice(this.sols.findIndex(t => t.id_ref_type_sol === typeSol.id_ref_type_sol), 1)
    },
    buildLocalSols () {
      return this.$store.getters.getSolCultureById(this.idCulture)
        .map(value => {
          return { ...value }
        })
    },
    calculDeletedSol () {
      return this.$store.getters.getSolCultureById(this.idCulture)
        .map(value => value.id_ref_type_sol)
        .filter(id => this.sols.findIndex(s => s.id_ref_type_sol === id) === -1)
    },

    addStade (stade) {
      // Ensure a stage is unique
      if (!this.stades.some(obj => obj.id_ref_stade === stade.id_ref_stade)) {
        this.stades.push({
          ...stade,
          dose: null,
          periode: null
        })
      }
    },

    deleteStade (typeSol) {
      this.stades.splice(
        this.stades.findIndex(t => t.id_ref_stade === typeSol.id_ref_stade),
        1
      )
    },
    buildLocalStades () {
      return this.$store.getters
        .getStadeCultureById(this.idCulture)
        .map(value => {
          return { ...value }
        })
    },
    calculDeletedStade () {
      return this.$store.getters
        .getStadeCultureById(this.idCulture)
        .map(value => value.id_ref_stade)
        .filter(id => this.stades.findIndex(s => s.id_ref_stade === id) === -1)
    },
    clearCipan () {
      this.localCulture.date_semis_cipan = null
      this.localCulture.date_levee_cipan = null
      this.localCulture.date_destruction_cipan = null
      this.localCulture.note_dev_cipan = null
    },
    isColzaCulture () {
      return this.localCulture.nom.indexOf('Colza') !== -1
    }
  },

  watch: {
    solsString: function () {
      this.fields['sols'].changed = true
    },
    stadesString: function () {
      this.fields['stades'].changed = true
    }
  }
}
</script>
